import { AccountBalance } from '../../model/Account-balance.model';
import axiosInstance from '../../utils/axiosInstance';

class AccountBalanceService {
  private readonly baseUrl = '/balance';
  async getAccountBalance(): Promise<AccountBalance> {
    const { data } = await axiosInstance.get(this.baseUrl);
    return data;
  }

  async addMoneyForBank(
    id: number,
    amount: number,
    employeeId: number
  ): Promise<AccountBalance> {
    const { data } = await axiosInstance.patch(
      `${this.baseUrl}/add-money/${id}/${employeeId}`,
      amount
    );
    return data;
  }

  async resetBalance(): Promise<void> {
    await axiosInstance.post(`${this.baseUrl}/reset-balance`);
  }
}

export default new AccountBalanceService();
